import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useUnreadCount = () => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) { setCount(0); return; }

    const fetchCount = async () => {
      // Use the denormalized unread counts from conversations table
      const { data: convos } = await supabase
        .from("conversations")
        .select("client_id, artisan_id, client_unread_count, artisan_unread_count")
        .or(`client_id.eq.${user.id},artisan_id.eq.${user.id}`);

      if (!convos || convos.length === 0) { setCount(0); return; }

      const total = convos.reduce((sum, c) => {
        if (c.client_id === user.id) return sum + (c.client_unread_count || 0);
        if (c.artisan_id === user.id) return sum + (c.artisan_unread_count || 0);
        return sum;
      }, 0);

      setCount(total);
    };

    fetchCount();

    // Subscribe to conversation updates (unread counts change via trigger)
    const channel = supabase
      .channel("unread-count")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "conversations" },
        () => fetchCount()
      )
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [user]);

  return count;
};
